// Datos ficticios de ejemplo para la plantilla "Editorial Botánica".
// Este objeto es la ÚNICA fuente de datos: la plantilla no hace consultas de red propias.
// Reemplazá estos valores con los datos reales de vuestro motor al integrarla.

export const datosEjemplo = {
  // Tema visual: se aplica como variables CSS (--wi-*) sobre la raíz de la plantilla.
  tema: {
    colores: {
      fondo: "#FAF9F6",
      fondoAlt: "#F3F1EC",
      texto: "#1A1918",
      textoSuave: "#52504C",
      textoTenue: "#85827A",
      primario: "#2A4034",
      primarioSuave: "#E8ECE8",
      acento: "#C5A059",
      borde: "rgba(42, 64, 52, 0.14)",
    },
    fuentes: {
      display: '"Cormorant Garamond", Georgia, serif',
      cuerpo: '"Montserrat", system-ui, sans-serif',
    },
  },

  // Visibilidad, orden y títulos editables de cada sección.
  // Para ocultar una sección: visible: false. Para reordenar: cambiar "orden".
  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "La cuenta regresiva", titulo: "Falta muy poco" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "El gran día", titulo: "Ceremonia y celebración" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Añadí la fecha a tu calendario" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Nosotros", titulo: "Momentos que nos trajeron hasta acá" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El programa", titulo: "Itinerario del día" },
    { id: "menciones", visible: true, orden: 6, etiqueta: "Nuestras familias", titulo: "Quienes nos acompañan" },
    { id: "video", visible: true, orden: 7, etiqueta: "Nuestra historia", titulo: "Mirá nuestro video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "La banda sonora", titulo: "La música de nuestra historia" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "¿Nos acompañás?" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Datos útiles", titulo: "Información adicional" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejá tu huella" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  pareja: {
    nombre1: "Sofía",
    nombre2: "Mateo",
    fraseIntroductoria: "Nos casamos",
    mensajePortada:
      "Tenemos el honor de invitarte a celebrar el día en que unimos nuestras vidas.",
    mensajeCierre:
      "Gracias por ser parte de nuestra historia. Los esperamos para celebrar juntos este nuevo comienzo.",
  },

  evento: {
    fechaISO: "2026-11-14T17:00:00-03:00",
    fechaLegible: "Sábado 14 de noviembre de 2026",
    fechaCorta: "14 · 11 · 2026",
    ciudad: "Asunción, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1510181414401-d3f2aa71a124?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1721401870202-8e2264ecced2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Sofía y Mateo caminando juntos al atardecer",
      },
      {
        src: "https://images.unsplash.com/photo-1698802060978-84008afaeb72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Las manos de la pareja con el anillo de compromiso",
      },
      {
        src: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Detalle de la mesa de celebración con flores blancas",
      },
      {
        src: "https://images.unsplash.com/photo-1569264630284-770de3d5935d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "La pareja abrazada entre la vegetación",
      },
    ],
  },

  eventos: [
    {
      id: "ceremonia",
      etiqueta: "Ceremonia religiosa",
      lugar: "Iglesia Santísima Trinidad",
      direccion: "Av. Santísima Trinidad esq. Cap. Figari, Asunción",
      horario: "17:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Iglesia+Sant%C3%ADsima+Trinidad+Asunci%C3%B3n",
      textoBoton: "Cómo llegar",
    },
    {
      id: "celebracion",
      etiqueta: "Recepción y fiesta",
      lugar: "Salón Jardín Los Arrayanes",
      direccion: "Ruta PY01 km 18, Villa Elisa",
      horario: "19:30 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Salon+Jardin+Villa+Elisa+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Boda Sofía & Mateo",
    descripcion:
      "Ceremonia 17:00 h en Iglesia Santísima Trinidad y recepción 19:30 h en Salón Jardín Los Arrayanes.",
    texto: "Sábado 14 de noviembre de 2026 · Asunción, Paraguay. Guardá la fecha para no perderte nada.",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2026-11-14T17:00:00-03:00",
    finISO: "2026-11-15T01:00:00-03:00",
    ubicacion: "Iglesia Santísima Trinidad, Asunción, Paraguay",
  },

  // Iconos disponibles: iglesia, copas, cena, musica, fiesta, brillo, camara, corazon, anillos, reloj
  itinerario: [
    { hora: "17:00", titulo: "Ceremonia religiosa", descripcion: "Ceremonia en Iglesia Santísima Trinidad.", icono: "iglesia" },
    { hora: "18:30", titulo: "Recepción y cóctel", descripcion: "Brindis de bienvenida en los jardines.", icono: "copas" },
    { hora: "19:30", titulo: "Cena", descripcion: "Menú de estación con opciones vegetarianas.", icono: "cena" },
    { hora: "21:30", titulo: "Primer baile", descripcion: "Abrimos la pista con nuestra canción.", icono: "musica" },
    { hora: "22:00", titulo: "Fiesta y cotillón", descripcion: "A bailar hasta que el cuerpo aguante.", icono: "fiesta" },
    { hora: "01:00", titulo: "Despedida", descripcion: "Cierre con una sorpresa para los que queden.", icono: "brillo" },
  ],

  menciones: [
    {
      nombre: "María Elina de Gómez",
      rol: "Madre de la novia",
      foto: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Carlos Roberto Gómez",
      rol: "Padre de la novia",
      foto: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Beatriz Benítez de Martínez",
      rol: "Madre del novio",
      foto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
    {
      nombre: "Jorge Luis Martínez",
      rol: "Padrino de la boda",
      foto: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=80&w=300&auto=format&fit=crop",
      instagramUrl: "https://instagram.com",
    },
  ],

  // Solo YouTube: la plantilla construye el embed a partir de la URL (nunca HTML arbitrario).
  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  // tipo: "spotify" | "mp3" — nunca ambos. Con "spotify" se usa la URL pública de la playlist/tema.
  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Presioná reproducir cuando quieras escucharla. La música nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Tu presencia es nuestro mejor regalo. Confirmanos tu asistencia para guardarte un lugar en nuestra mesa.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 14 de octubre de 2026",
  },

  enlaces: [
    { texto: "Hoteles recomendados", url: "https://www.booking.com/city/py/asuncion.es.html" },
    { texto: "#SofiaYMateo2026 en Instagram", url: "https://www.instagram.com" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejanos un mensaje o dedicatoria para atesorar.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Sumá las fotos que saques durante la fiesta.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
